import { useComponentLoadingStateStore } from "../store/useComponentLoadingStateStore";

export const closeAllNavMenus = (cb?: any) => {
  useComponentLoadingStateStore.setState({ isSideNavOpen: false });
  useComponentLoadingStateStore.setState({ isMenuExpanded: false });
  if (!cb) return;
  cb();
};
